import * as Function from "../Function";
import * as Error from "../Error";
import * as ErrorCode from "../ErrorCode";
import { option } from "fp-ts/lib";

export const required: Function.TValidationFunction = (value: unknown): option.Option<Error.TValidationError> =>
    value === undefined
        ? option.some([[ErrorCode.validationErrorCodeConstants.REQUIRED_VALIDATION]]) : option.none;
